/**
 * Gestion centralisée des erreurs AJAX (correctif global du chantier J).
 *
 * AVANT : chaque fichier front dupliquait `redirectAfterAjaxError`, qui redirigeait TOUJOURS vers
 * /connexion sur la moindre erreur AJAX — bug : `querySelectorAll('.flash-info')` renvoie une NodeList
 * toujours « truthy » (même vide), donc le test `if (getFlashInfo)` était toujours vrai.
 *
 * APRÈS (révisé 2026-07-07, demande OPH) : on ne redirige JAMAIS vers /connexion sur une erreur AJAX.
 * Toute erreur affiche une modale d'erreur générique. Les vraies erreurs (hors session expirée, détectée
 * via `.flash-info`/401 par classifyAjaxError) sont REMONTÉES au serveur (/client-error) qui les journalise
 * et peut alerter dev@prox-i.pf. classifyAjaxError ne décide donc plus d'une redirection, seulement du report.
 *
 * CommonJS (require/module.exports) : la partie pure est testée par Jest ; consommé par Webpack.
 */
'use strict';

/**
 * Décision PURE (testable) : 'auth' = session expirée -> redirige login ; 'error' = vraie erreur -> modale.
 */
function classifyAjaxError(err) {
    var status = (err && typeof err.status === 'number') ? err.status : 0;
    if (status === 401) {
        return 'auth';
    }
    var body = (err && typeof err.responseText === 'string') ? err.responseText : '';
    // Le serveur renvoie la page de login (avec un bloc .flash-info) quand la session a expiré.
    if (body.indexOf('flash-info') !== -1) {
        return 'auth';
    }
    return 'error';
}

/** Construit le payload d'incident (pur, testable) — identifiants techniques uniquement. */
function buildErrorPayload(err) {
    var loc = (typeof location !== 'undefined') ? location : { pathname: '', href: '' };
    var ua = (typeof navigator !== 'undefined') ? navigator.userAgent : '';
    var body = (err && typeof err.responseText === 'string') ? err.responseText : '';
    return {
        status: (err && err.status) || 0,
        statusText: (err && err.statusText) || '',
        page: loc.pathname || loc.href || '',
        message: body.slice(0, 500),
        userAgent: ua
    };
}

/** Remonte l'incident au serveur (fire-and-forget ; ne JAMAIS rappeler handleAjaxError ici -> pas de boucle). */
function reportClientError(err) {
    try {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/client-error', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify(buildErrorPayload(err)));
    } catch (e) { /* best-effort */ }
}

/** Masque le loader plein écran (convention `.loader_div`) : sinon il reste affiché derrière la modale. */
function hideLoader() {
    if (typeof document === 'undefined') {
        return;
    }
    var loaders = document.querySelectorAll('.loader_div');
    for (var i = 0; i < loaders.length; i++) {
        loaders[i].style.display = 'none';
    }
}

/** Modale d'erreur auto-contenue (aucune dépendance Bootstrap : fonctionne sur toutes les pages). */
function showErrorModal(message) {
    hideLoader();
    if (typeof document === 'undefined' || document.getElementById('oph-ajax-error-modal')) {
        return;
    }
    var overlay = document.createElement('div');
    overlay.id = 'oph-ajax-error-modal';
    overlay.setAttribute('role', 'alertdialog');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(16,37,68,.55);z-index:99999;display:flex;align-items:center;justify-content:center;';
    overlay.innerHTML =
        '<div style="background:#fff;max-width:430px;width:90%;border-radius:12px;padding:24px 26px;box-shadow:0 8px 28px rgba(16,37,68,.25);font-family:-apple-system,Segoe UI,Roboto,Arial,sans-serif;">' +
        '<h3 style="margin:0 0 10px;font-size:18px;color:#16233b;">Une erreur est survenue</h3>' +
        '<p style="margin:0 0 18px;font-size:14px;line-height:1.5;color:#43526b;">' +
        (message || "Votre action n'a pas pu aboutir. L'incident a été signalé à notre équipe technique. Merci de réessayer dans un instant.") +
        '</p>' +
        '<button type="button" id="oph-ajax-error-close" style="background:#1d4ed8;color:#fff;border:0;border-radius:8px;padding:9px 18px;font-size:14px;cursor:pointer;">Fermer</button>' +
        '</div>';
    document.body.appendChild(overlay);
    var close = function () {
        var n = document.getElementById('oph-ajax-error-modal');
        if (n && n.parentNode) { n.parentNode.removeChild(n); }
    };
    overlay.addEventListener('click', function (e) { if (e.target === overlay) { close(); } });
    var btn = document.getElementById('oph-ajax-error-close');
    if (btn) { btn.addEventListener('click', close); }
}

/** Point d'entrée unique : remplace l'ancien redirectAfterAjaxError dans tous les fichiers front. */
function handleAjaxError(err) {
    // Demande OPH (2026-07-07) : PLUS AUCUNE redirection vers /connexion sur une erreur AJAX, où que ce
    // soit. Toute erreur affiche désormais une modale générique. On continue de remonter au serveur
    // (/client-error) les vraies erreurs — hors session expirée, qui n'est pas un incident à journaliser.
    if (classifyAjaxError(err) !== 'auth') {
        reportClientError(err);
    }
    showErrorModal();
}

module.exports = {
    classifyAjaxError: classifyAjaxError,
    buildErrorPayload: buildErrorPayload,
    reportClientError: reportClientError,
    hideLoader: hideLoader,
    showErrorModal: showErrorModal,
    handleAjaxError: handleAjaxError
};
